<template>
  <div class="container mx-auto lg:my-20 md:my-20">
    <div
      class="bg-efe8f9 md:rounded-3xl lg:rounded-3xl rounded-xl md:p-8 lg:p-8 p-4 shadow-b-2xl relative"
    >
      <div>
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
            <div
              class="pt-6 grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 gap-x-5 lg:gap-y-6 md:gap-y-6"
            >
              <div class="">
                <p class="input-title text-primary">
                  First Name<span class="clr-red">*</span>
                </p>
                <base-input
                  v-model="firstName"
                  placeholder="Enter your First Name"
                  class="md:border-0 lg:border-0 custipshadow"
                  name="First Name"
                  :rules="{ required: true, regex: /^[A-Za-z\s]+$/ }"
                  @input="
                    firstName = firstName
                      .replace(/[^A-Za-z\s]/g, '')
                      .replace(/\s{2,}/g, ' ')
                  "
                ></base-input>
              </div>
              <div class="">
                <p class="input-title text-primary">
                  Last Name<span class="clr-red">*</span>
                </p>
                <base-input
                  v-model="lastName"
                  placeholder="Enter your Last Name"
                  class="md:border-0 lg:border-0 custipshadow"
                  name="Last Name"
                  :rules="{ required: true, regex: /^[A-Za-z\s]+$/ }"
                  @input="
                    lastName = lastName
                      .replace(/[^A-Za-z\s]/g, '')
                      .replace(/\s{2,}/g, ' ')
                  "
                ></base-input>
              </div>

              <div class="">
                <p class="input-title text-primary">
                  Mobile No.<span class="clr-red">*</span>
                </p>
                <base-input
                  v-model="mobile"
                  placeholder="Enter your Mobile No."
                  class="md:border-0 lg:border-0 custipshadow"
                  name="Mobile No."
                  :rules="{ required: true, regex: /^[0-9]{10}$/ }"
                  @input="mobile = mobile.replace(/\D/g, '').slice(0, 10)"
                ></base-input>
              </div>
              <div class="">
                <p class="input-title text-primary">
                  Email Address<span class="clr-red">*</span>
                </p>
                <base-input
                  v-model="email"
                  placeholder="Enter your EmailID"
                  class="md:border-0 lg:border-0 custipshadow"
                  name="Email"
                  :rules="{ required: true, email: true }"
                  @input="email = email.toLowerCase()"
                ></base-input>
              </div>

              <div class="">
                <p class="input-title text-primary">
                  City<span class="clr-red">*</span>
                </p>
                <base-input
                  v-model="city"
                  placeholder="Enter your city name"
                  class="md:border-0 lg:border-0 custipshadow"
                  name="City"
                  :rules="{ required: true, alpha_spaces: true }"
                ></base-input>
                <!-- <b-form-select
                v-model="City"
                placeholder="Select city"
                :options="options"
                class="md:border-0 lg:border-0 custipshadow"
                name="city"
              >
                <b-form-select-option :value="null"
                  >Please select an option</b-form-select-option
                >
                <b-form-select-option value="a">Option A</b-form-select-option>
                <b-form-select-option value="b" disabled
                  >Option B (disabled)</b-form-select-option
                >
              </b-form-select> -->
              </div>
              <div class="">
                <p class="input-title text-primary">
                  Type of Art<span class="clr-red">*</span>
                </p>
                <b-form-select
                  v-model="art"
                  placeholder="Select Artwork"
                  class="md:border-0 lg:border-0 custipshadow"
                  name="city"
                >
                  <b-form-select-option :value="null"
                    >Please select an option</b-form-select-option
                  >
                  <b-form-select-option value="Poetry"
                    >Poetry</b-form-select-option
                  >
                  <b-form-select-option value="Photo"
                    >Photo</b-form-select-option
                  >
                  <b-form-select-option value="Video"
                    >Video</b-form-select-option
                  >
                  <b-form-select-option value="Prose" class="textcolor"
                    >Prose</b-form-select-option
                  >
                </b-form-select>
              </div>
            </div>

            <div
              class="lg:mt-6 md:mt-6 mt-6"
              v-if="art === 'Photo' || art === 'Poetry' || art === 'Prose'"
            >
              <!-- <FileUploader /> -->
              <p class="input-title text-primary">Photo</p>
              <!-- <el-upload
                class="upload-demo"
                :auto-upload="false"
                action="#"
                list-type="picture-card"
                accept="image/*"
                :on-change="handleImageChange"
                :on-remove="handleImageRemove"
                :before-upload="beforeUpload"
                :limit="1"
              >
                <i slot="default" class="el-icon-plus"></i>
              </el-upload> -->
              <div class="grid grid-cols-2 gap-6">
                <div
                  class="relative cursor-pointer bg-fa dash-primary w-full h-40 rounded-lg overflow-hidden flex items-center justify-center"
                >
                  <div v-if="!imagePreview">
                    <p class="fsize14 text-center text-gray">Upload Here</p>
                  </div>
                  <input
                    type="file"
                    class="uploads absolute top-0 left-0 w-full h-40 opacity-0 cursor-pointer"
                    accept="image/*"
                    @change="handleImageUpload"
                  />
                </div>

                <div v-if="imagePreview" class="relative">
                  <img
                    :src="imagePreview"
                    alt="Uploaded"
                    class="w-full h-40 object-cover rounded-lg"
                  />
                  <div class="absolute top-0 right-0 m-1">
                    <div
                      class="w-6 h-6 rounded-full flex items-center justify-center bg-white cursor-pointer"
                      @click="removeImage"
                    >
                      <feather-icon
                        icon="XIcon"
                        svgClasses="w-4 h-4"
                        class="flex text-primary"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="art === 'Video' || art === 'Poetry' || art === 'Prose'"
              class="pt-3"
            >
              <div>
                <!-- <div class="lg:mt-8 md:mt-8">
                <FileUploader />
              </div> -->
                <p class="input-title text-primary">Video</p>
                <el-upload
                  class="upload-demo"
                  :auto-upload="false"
                  action="#"
                  accept="video/mp4,video/x-m4v,video/*"
                  :on-change="handleVideoChange"
                  :on-remove="handleVideoRemove"
                >
                  <!-- <i class="el-icon-upload"></i>

                <div class="el-upload__text">
                  Drop file here or <em>click to upload</em>
                </div> -->
                  <b-button
                    variant="primary"
                    class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 border-2 text-base font-bold flex m-auto"
                    >Upload Video</b-button
                  >

                  <!-- <div class="el-upload__tip" slot="tip">
                  jpg/png files with a size less than 500kb
                </div> -->
                </el-upload>
              </div>
              <div class="pt-3">OR</div>
              <div class="pt-3">
                <p class="input-title text-primary">Video URL</p>
                <base-input
                  v-model="videoUrl"
                  placeholder="Enter your Video Url"
                  class="md:border-0 lg:border-0 custipshadow"
                  name="videoUrl"
                  :rules="{}"
                ></base-input>
              </div>
            </div>

            <div class="pt-3" v-if="art === 'Poetry'">
              <p class="input-title text-primary">Poetry Heading</p>
              <base-input
                v-model="poetryHeading"
                placeholder="Enter your Poetry Heading"
                class="md:border-0 lg:border-0 custipshadow"
                name="Poetry Heading"
                :rules="{ required: true }"
              ></base-input>
            </div>

            <div class="pt-4 md:mb-0 lg:mb-0 mb-14">
              <p class="input-title text-primary">Message / Description</p>
              <!-- <b-form-textarea
              v-model="message"
              placeholder="Describe in few words"
              rows="5"
              class="md:border-0 lg:border-0 custipshadow"
            ></b-form-textarea> -->
              <quill-editor
                v-model="message"
                :options="editorOption"
                class="quill-h200px my-2 bg-white"
              />
            </div>
            <!-- <vue-recaptcha
                      sitekey="6LfZLWkeAAAAALwhHWrc9kPpHsS3KOGzMZNXXNW6"
                      :loadRecaptchaScript="true"
                      ref="recaptcha"
                    > -->

            <!-- :disabled="!isValidForm" -->
            <div class="mt-8">
              <b-form-checkbox
                class="text-white"
                id="checkbox-1"
                v-model="artWorkPermission"
              >
                <p>
                  <strong>
                    <u class="text-primary" @click="editModal = true"
                      >I consent to give my permission to Caregiver Saathi for
                      using this content</u
                    ></strong
                  >
                </p></b-form-checkbox
              >
            </div>
            <div class="mt-8">
              <b-button
                type="submit"
                variant="primary"
                native-type="submit"
                :disabled="!artWorkPermission"
                class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 border-2 text-base font-bold flex m-auto"
                >Submit</b-button
              >
            </div>
            <!-- </vue-recaptcha>  -->
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import FileUploader from "@/components/FileUploader.vue";
import { Upload } from "element-ui";
import { mapState } from "vuex";
export default {
  components: {
    FileUploader,
    quillEditor,
    [Upload.name]: Upload,
  },
  data() {
    return {
      art: null,
      city: "",
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      message: "",
      videoUrl: "",
      poetryHeading: "",
      // art: "Poetry",
      // city: "Mumbai",
      // firstName: "Maneesh",
      // lastName: "Mashelkar",
      // email: "maneesh.mashelkar@aiab.in",
      // mobile: "9892169576",
      // message: "testing",
      // videoUrl: "test.com",
      video: null,
      selectedFile: null,
      imagePreview: null,
      images: [],
      artWorkPermission: false,
      editorOption: {
        theme: "snow",
      },
    };
  },
  computed: {
    ...mapState("auth", { user: "user" }),
    // isValidForm() {
    // if (this.art === "Photo") {
    // if (
    //   this.firstName !== "" ||
    //   this.lastName !== "" ||
    //   this.email !== "" ||
    //   this.mobile !== "" ||
    //   this.artWorkPermission !== false ||
    //   this.message !== "" ||
    //   this.city !== ""
    // ) {
    //   return true;
    // }
    // return false;
    // }
    // return false;
    // },
  },
  methods: {
    beforeUpload(file) {
      if (this.fileListImage.length >= 1) {
        this.$message.warning("You can only upload one image");
        return false;
      }
      return true;
    },
    handleVideoChange(file, fileList) {
      let mByte = 5 * 1048576;
      if (file.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        fileList.pop();
        return;
      }
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.video = fileList[0].raw;
    },
    handleVideoRemove(file, fileList) {
      const index = fileList.indexOf(file);
      fileList.splice(index, 1);
      this.video = null;
    },
    handleImageChange(file, fileList) {
      let mByte = 5 * 1048576;
      if (file.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        fileList.pop();
        return;
      } else {
        this.images = fileList.map((data) => data.raw);
      }
    },
    handleImageRemove(file, fileList) {
      // console.log(file);
      // const index = fileList.findIndex((item) => item.uid === file.uid);
      // console.log(index);
      // if (index !== -1) {
      //   console.log(index);
      //   fileList.splice(index, 1);
      //   this.images = fileList.map((data) => data.raw);
      //   console.log(this.images);
      // }
      fileList = fileList.filter((item) => item.uid !== file.uid);
      this.images = fileList.map((data) => data.raw);
      // console.log(fileList);
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      const mByte = 5 * 1048576; // 5 MB
      if (file.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });

        const fileInput = document.querySelector(".uploads");
        if (fileInput) fileInput.value = "";

        return;
      }
      this.selectedFile = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imagePreview = reader.result;
      };
    },

    removeImage() {
      this.selectedFile = null;
      this.imagePreview = null;
      const fileInput = document.querySelector(".uploads");
      if (fileInput) {
        fileInput.value = "";
      }
    },

    resetForm() {
      this.art = null;
      this.city = "";
      this.firstName = "";
      this.lastName = "";
      this.email = "";
      this.mobile = "";
      this.message = "";
      this.videoUrl = "";
      this.poetryHeading = "";
      this.video = null;
      this.images = [];
      this.selectedFile = null;
      this.imagePreview = null;
      this.artWorkPermission = false;
      this.removeImage();
      if (this.$refs.formValidator && this.$refs.formValidator.reset) {
        this.$refs.formValidator.reset();
      }
    },
    showApiError(error, fallback) {
      const message =
        (error &&
          error.response &&
          error.response.data &&
          (error.response.data.message || error.response.data.error)) ||
        fallback;
      this.$swal.fire({
        text: message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
      });
    },
    async onSubmit() {
      if (this.art === null) {
        this.$swal.fire({
          text: `Please Select Art!`,
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      if (this.art === "Poetry" && this.message === "") {
        this.$swal.fire({
          text: `Please Enter Message!`,
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }

      let FormData = require("form-data");
      let data = new FormData();
      data.append("firstName", this.firstName);
      data.append("lastName", this.lastName);
      data.append("email", this.email);
      data.append("mobile", this.mobile);
      data.append("city", this.city);
      data.append("art", this.art);
      data.append("isAdmin", "false");
      if (this.message) data.append("message", this.message);
      if (this.video) data.append("video", this.video);
      if (this.videoUrl) data.append("videoUrl", this.videoUrl);
      if (this.poetryHeading) data.append("poetryHeading", this.poetryHeading);
      if (this.selectedFile) {
        data.append("images", this.selectedFile);
      }

      data.append("artWorkPermission", this.artWorkPermission ? "true" : "false");

      let loader = this.$loading();

      if (this.art === "Video" && this.video === null && this.videoUrl === "") {
        this.$swal.fire({
          text: "Please Select Video or Video Url",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }

      if (this.art === "Photo" && !this.selectedFile) {
        this.$swal.fire({
          text: "Please Select image",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }

      try {
        const shareWorkData = await this.$store.dispatch(
          "hoc/createSharework",
          data
        );
        if (shareWorkData && shareWorkData.code == 200) {
          this.$swal.fire({
            text: "Share Your Work Form Submitted Successfully",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.resetForm();
        } else {
          this.showApiError(
            null,
            (shareWorkData && shareWorkData.message) ||
              "Unable to submit artwork. Please try again."
          );
        }

        loader.close();
      } catch (error) {
        loader.close();
        this.showApiError(
          error,
          "Unable to submit artwork. Please try again."
        );
      }
    },
  },
  mounted() {
    if (!!Object.keys(this.user).length) {
      this.email = this.user.email;
      this.firstName = this.user.firstname;
      this.lastName = this.user.lastname;
      this.mobile = this.user.mobile;
    }
  },
};
</script>
